import React from "react";
import {findDOMNode} from "react-dom";
import Popover from "../../../../../gd-components/gd-popover/popover-v2";
import PopoverPosition from "../../../../../gd-components/gd-popover/popover-position";
import FieldProto from "../../../../proto/field-proto";

type Props = {
    parent      : any,
    field       : FieldProto
}

type State = {
    searchString        : null | string
}

export default class FieldPopover_Popover extends React.Component<Props,State> {


    constructor(props:any) {
        super(props);

        this.state = {
            searchString: null
        }
    }

    render() {
        return (
            <Popover position={new PopoverPosition({attachment: "top center", targetAttachment: "bottom center"})}
                     getTargetFunc={()=>findDOMNode(this.props.parent)}
                     onClickOutside={()=>{this.props.parent.hidePopover()}}>

                Proto example popover menu

            </Popover>
        );
    }
}
